import React, { useState, useRef } from 'react';
import { FiMoreVertical, FiDownload, FiUpload, FiAnchor } from 'react-icons/fi';
import Button from './ui/Button';
import PortaledMenu from './ui/PortaledMenu';

const ScheduleOptionsMenu = ({
    currentDraftName = null,
    onFileUpload,
    onExport,
    isImporting = false,
    isExporting = false,
    importError,
    isLoading = false,
    error,
    setError,
    onToggleDebug
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const fileInputRef = React.useRef(null);
    const menuButtonRef = useRef(null);

    const handleImportClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
        setIsMenuOpen(false);
    };

    const handleExportClick = () => {
        if (onExport) {
            onExport();
        }
        setIsMenuOpen(false);
    };

    const handleToggleDebug = () => {
        if (onToggleDebug) {
            onToggleDebug();
        }
        setIsMenuOpen(false);
    };

    return (
        <div className="relative" ref={menuButtonRef}>
            {/* Options Button */}
            <Button
                variant="outline"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                disabled={isLoading}
                className="flex items-center"
            >
                <FiMoreVertical className="w-5 h-5" />
            </Button>

            <PortaledMenu
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
                anchorRef={menuButtonRef}
                align="right"
                className="w-64 bg-white border border-gray-200 rounded-lg shadow-lg"
            >
                <div className="p-2">


                    {/* Import/Export */}
                    <div>
                        <div className="text-xs text-gray-500 uppercase tracking-wide px-3 py-1">Import/Export</div>
                        <button
                            onClick={handleImportClick}
                            disabled={isLoading || isImporting}
                            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded flex items-center gap-2 disabled:text-gray-400"
                        >
                            <FiDownload className="w-4 h-4" /> {isImporting ? 'Importing...' : 'Import Schedule...'}
                        </button>

                        <button
                            onClick={handleExportClick}
                            disabled={isLoading || isExporting}
                            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded flex items-center gap-2 disabled:text-gray-400"
                        >
                            <FiUpload className="w-4 h-4" /> {isExporting ? 'Exporting...' : `Export ${currentDraftName || 'schedule'}...`}
                        </button>
                    </div>

                    {/* Debug Toggle */}
                    {onToggleDebug && (
                        <div className="pt-2">
                            <button
                                onClick={handleToggleDebug}
                                className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded flex items-center gap-2"
                            >
                                <FiAnchor className="w-4 h-4" /> Show Debug Info
                            </button>
                        </div>
                    )}
                </div>
            </PortaledMenu>

            {/* Hidden file input for import */}
            <input
                ref={fileInputRef}
                type="file"
                accept=".json,.csv"
                onChange={onFileUpload}
                style={{ display: 'none' }}
            />

            {/* Error Messages - Success messages are handled by parent component */}
            {(error || importError) && (
                <div className="fixed top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
                    <span className="block sm:inline">{error || importError}</span>
                    <button
                        className="float-right ml-4 text-red-500 hover:text-red-700"
                        onClick={() => {
                            if (setError) setError(null);
                            // Note: importError is managed by parent component
                        }}
                    >
                        ×
                    </button>
                </div>
            )}
        </div>
    );
};

export default ScheduleOptionsMenu;
